"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autowired = void 0;
require("reflect-metadata");
var const_1 = require("./const");
var utils_1 = require("../utils");
var base_1 = require("./base");
var Autowired = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return function (target, attrKey) {
        var TargetFactory = Reflect.getMetadata("design:type", target, attrKey);
        Object.defineProperty(target, attrKey, {
            configurable: false,
            enumerable: true,
            get: function () {
                var instanceId = Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INSTANCEID, target) ||
                    Reflect.getMetadata(const_1.CONST_DECORATOR_FOR_MODULE_INSTANCEID, target.constructor);
                if (!utils_1.utils.isEmpty(instanceId)) {
                    return base_1.createInstance(TargetFactory, instanceId);
                }
                else {
                    return new Error("Not running in the application");
                }
            },
            set: function () {
                throw new Error("使用Autowired初始化的对象不允许重写.");
            }
        });
    };
};
exports.Autowired = Autowired;
